import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, Col, Container } from "reactstrap";
import iconSrc from '~/assets/images/desktop/finish-screen-icon.svg';
import progressSrc from '~/assets/images/desktop/progress-bar-complete.png';
import { useAuth } from "~/context/auth";
import DesktopMenu from "~/components/Shared/DesktopMenu";
import { getOrder } from "~/helpers/backendHelper";
import { getBeUrl } from "~/helpers/utilHelper";
import { addAccessToken } from "~/helpers/tokenHelper";
import NotFound from "~/pages/Error/NotFound";
import MailBox from "~/assets/images/desktop/markunread_mailbox.png";
import textSnippet from "~/assets/images/desktop/text_snippet.png";
import menuSteps from "~/constants/menuSteps";
import OrderSigner from '~/model/orderSigner';
import finishSrc from "~/assets/images/desktop/finish-screen-banner.png";
import Order from "~/model/order";

const DesktopContent = () => {

  const { user: authUser } = useAuth();

  const [order, setOrder] = useState<Order | null>(null);
  const [orderError, setOrderError] = useState(false);

  // runs once on component mount
  useEffect(() => {
    getOrder().then(res => {
      if (!res.order) {
        setOrderError(true);
        return;
      }
      setOrder(res.order)
    }).catch(_err => {
      setOrderError(true);
    })
  }, []);

  return <React.Fragment>
    <DesktopMenu title={"Finish"} activeStep={menuSteps.FINISH} />
    <Container>
      <div className="justify-content-center d-flex">
        <img className="header-image-finish-desktop" src={finishSrc} />
      </div>
      <Row className="justify-content-center">
        <Col md={8} lg={6} xl={6} className="finish-column desktop">
          <Card className="mb-2">
            <CardBody>
              <div className="pt-1 text-center">
                <img className="mt-3 verif-icon" src={iconSrc}></img>
                <h5 className="mt-5 mb-4 finish-name">Thank you {authUser?.fullName}!</h5>
                <img src={progressSrc} className="mb-3"></img>
                {
                  order?.customerLocation === Order.CUSTOMER_LOCATION_IN_STORE && <>
                    <p className="finish-message-desktop mb-2">Your insurance has been submitted successfully.</p>
                    <p className="finish-message-desktop mb-2">You can leave this page now.</p>
                  </>
                }
                {
                  order?.customerLocation === Order.CUSTOMER_LOCATION_REMOTE && <>
                    <p className="finish-message-desktop mb-2">All your documents have been submitted successfully.</p>
                    {authUser?.type === OrderSigner.TYPE_CUSTOMER &&
                      <p className="finish-message-desktop">Your dealership representative will be in touch with you shortly. </p>
                    }
                    <p className="finish-name">You can leave this page now.</p>
                    {!!order && !!order.returnShippingLabel && <div className="return-label-text">
                      <div className="finish-message-desktop return-label p-3 d-flex ms-3">
                        <img src={MailBox} alt="" className="return-label-img" />
                        <span>A Return Envelope will be provided with the documents. If no return envelope is included, your Maverick scheduler will contact the dealership for the return label.</span>
                      </div>
                      <div className="finish-message-desktop return-label p-3 d-flex me-3">
                        <img src={textSnippet} alt="" className="return-label-img" />
                        <span>Make sure you include all the original signed documents to the envelope and seal it properly. Go to your nearest FedEx/UPS as soon as possible.</span>
                      </div>
                    </div>}
                  </>
                }
              </div>
            </CardBody>
          </Card>
          {!!order && !!order.returnShippingLabel && <>
            <div className="pb-2 text-center">
              <a href={getBeUrl(addAccessToken(`order/return-label/download`))} className="btn btn-primary w-100">
                <div className="d-flex justify-content-center align-items-center">
                  <span className="fw-medium text-start pe-2 finish-message-desktop">Download Return Label</span>
                  <i className="bx bx-download font-size-20" />
                </div>
              </a>
            </div>
          </>}
        </Col>
      </Row>
    </Container>
    {orderError && <NotFound />}
  </React.Fragment>
}

export default DesktopContent;
